import { Component } from '@angular/core';
import { SecuredLinkComponent } from './secured-link.component';

@Component({
  selector: 'miq-secured-download-link',
  template: `
    <ng-container *ngIf="src$ | async as src; else failureLink">
      <a
        mat-button
        rel="noopener noreferrer"
        [href]="src"
        [target]="target"
        download="{{ fileName || 'file' }}"
        [disabled]="disabled"
      >
        <ng-content select="[content]"></ng-content>
      </a>
    </ng-container>

    <ng-template #failureLink>
      <a mat-button class="failure-link" disabled>
        <ng-content select="[failure]"></ng-content>
      </a>
    </ng-template>
  `,
  standalone: false,
})
export class SecuredDownloadLinkComponent extends SecuredLinkComponent {}
